import React from "react";
import { useI18n } from "../i18n/I18nContext";

const MAP = {
  pending: { bg: "bg-amber-500/15", text: "text-amber-400", ring: "ring-amber-500/30", dot: "bg-amber-400" },
  active: { bg: "bg-emerald-500/15", text: "text-emerald-400", ring: "ring-emerald-500/30", dot: "bg-emerald-400" },
  disabled: { bg: "bg-rose-500/15", text: "text-rose-400", ring: "ring-rose-500/30", dot: "bg-rose-400" },
  suspended: { bg: "bg-orange-500/15", text: "text-orange-400", ring: "ring-orange-500/30", dot: "bg-orange-400" },
  expired: { bg: "bg-slate-500/15", text: "text-slate-400", ring: "ring-slate-500/30", dot: "bg-slate-400" },
  online: { bg: "bg-emerald-500/15", text: "text-emerald-400", ring: "ring-emerald-500/30", dot: "bg-emerald-400" },
  offline: { bg: "bg-rose-500/15", text: "text-rose-400", ring: "ring-rose-500/30", dot: "bg-rose-400" },
  accept: { bg: "bg-emerald-500/15", text: "text-emerald-400", ring: "ring-emerald-500/30", dot: "bg-emerald-400" },
  reject: { bg: "bg-rose-500/15", text: "text-rose-400", ring: "ring-rose-500/30", dot: "bg-rose-400" },
  active_st: { bg: "bg-emerald-500/15", text: "text-emerald-400", ring: "ring-emerald-500/30", dot: "bg-emerald-400" },
  inactive: { bg: "bg-slate-500/15", text: "text-slate-400", ring: "ring-slate-500/30", dot: "bg-slate-400" },
};

export function WifiBadge({ status, live = false }) {
  const { t } = useI18n();
  const c = MAP[status] || MAP.expired;
  const label = { pending: t("wifi.pending"), active: t("wifi.active"), disabled: t("wifi.disabled"), suspended: t("wifi.suspended"), expired: t("wifi.expired") }[status] || status;
  return (
    <span data-testid={`wifi-badge-${status}`} className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ${c.bg} ${c.text} ${c.ring}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${c.dot} ${live ? "live-dot" : ""}`} />
      {label}
    </span>
  );
}

export function StatusBadge({ status, label }) {
  const c = MAP[status] || MAP.expired;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ${c.bg} ${c.text} ${c.ring}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${c.dot}`} />
      {label || status}
    </span>
  );
}
